import type {ReactNode} from 'react';

import {META_TEXT_MENTION_PATTERN} from '../constants/metaTextMentionPattern';

/**
 * Splits a META_TEXT cell value into renderable segments. Plain text passes
 * through unchanged; `@[Display Name](entity-id)` mentions render as a
 * highlighted chip showing only the display label.
 *
 * A value with no mention markup yields a single text segment — the common
 * case, since most notes are written without mentioning anyone.
 */
export const parseMetaText = (cellValue: string): ReactNode[] => {
  const segments: ReactNode[] = [];
  let lastIndex = 0;

  const matches = Array.from(cellValue.matchAll(META_TEXT_MENTION_PATTERN));

  matches.forEach((match, index) => {
    const matchStart = match.index ?? 0;
    const matchEnd = matchStart + match[0].length;

    if (matchStart > lastIndex) {
      segments.push(cellValue.substring(lastIndex, matchStart));
    }

    const name = match[1];
    const id = match[2];

    segments.push(
      // eslint-disable-next-line react/no-array-index-key -- Pre-existing violation
      <span key={`meta-${index}-${id}`} className="bg-[color:var(--color-blue-30,#e3f0ff)] inline">
        {name}
      </span>
    );

    lastIndex = matchEnd;
  });

  if (lastIndex < cellValue.length) {
    segments.push(cellValue.substring(lastIndex));
  }

  return segments;
};
